import { createApi } from "@reduxjs/toolkit/query/react";
import customBaseQuery from "../../../utils/customBaseQuery";

export const LearnerAgendaApi = createApi({
  reducerPath: "LearnerAgendaApi",
  baseQuery: customBaseQuery,
  tagTypes: ["agendas"],
  endpoints: (builder) => ({
    postLearnerAgenda: builder.query({
      query: (body: any) => {
        return {
          url: `/search/agendas?type=learner`,
          method: "POST",
          body: body
        };
      }
    })
  })
});

export const { usePostLearnerAgendaQuery } = LearnerAgendaApi;
